export default {
  MODULE: {
    APPOINTMENT: {
      STATUS: 'Updated: Appointment Status'
    },
    CARRIER: {
      CREATED: 'Created: Carrier Contact'
    },
    COMPANY: {
      CREATED: 'Created: Carrier Company'
    },
    REPORTING: {
      REPORTING_EXPORTED: makeActionEvent('Report Exported'),
      VIEW_PAGE: makeViewEvent('Insights Page')
    },
    SELF_CHECK_IN: {
      SELF_CHECK_IN_REQUESTED: makeActionEvent('Self Check-in Requested'),
      APPOINTMENT_LINKED: makeActionEvent('Asset and Appointment Linked'),
      APPOINTMENT_UNLINKED: makeActionEvent('Asset and Appointment Unlinked'),
      CTA_CLICKED: 'Clicked: Gate Management CTA'
    },
    CUSTOM_FORMS: {
      ACTIVATE_FIELD: 'Activated: Field',
      DEACTIVATE_FIELD: 'Deactivated: Field'
    }
  },
  ACTION: {
    COPIED_APPOINTMENT_ID: makeActionEvent('Appointment ID Copied'),
    SEARCH_APPOINTMENTS: makeActionEvent('Search Appointments')
  },
  SYSTEM: {
    ERROR: {
      WEBSOCKET_CONNECTION: makeErrorEvent('Websocket connection failure')
    }
  }
};

function makeViewEvent(event) {
  return `Viewed: ${event}`;
}

function makeActionEvent(event) {
  return `Action: ${event}`;
}

function makeErrorEvent(error) {
  return `Error: ${error}`;
}
